import { Center, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Priority } from 'models/rules';
import { InfoCard } from '../InfoCard/InfoCard';
import { PriorityCard } from '../PriorityCard/PriorityCard';

export const WidgetOpenAlerts = () => {
  const { t } = useTranslation();

  return (
    <InfoCard title={t('dashboard_open_alerts')} tooltip={t('dashboard_open_alerts_tooltip')} testId={'new-alerts'}>
      <Center mt={'md'}>
        <Group gap={'xl'}>
          {Object.values(Priority).map((priority) => (
            <PriorityCard key={priority} priority={priority} />
          ))}
        </Group>
      </Center>
    </InfoCard>
  );
};
